import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-consulta-precificador',
  templateUrl: './consulta-precificador.component.html',
  styleUrls: ['./consulta-precificador.component.scss']
})
export class ConsultaPrecificadorComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';
  msg;

  @Input() token = '';

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {

  }

}
